module.exports = __webpack_public_path__ + "static/img/scared.4d59df57.png";